import { entity } from 'simpler-state';

import { EpicMoversQueryOption } from '../../models/fundamental/types';

export const epicMoversFilterOption = entity<EpicMoversQueryOption>(EpicMoversQueryOption.FROM_15_TO_50);

export const setEpicMoversFilterOption = (newOption: EpicMoversQueryOption) => {
  epicMoversFilterOption.set(newOption);
};
